// extracted by mini-css-extract-plugin
export default {"main":"styles_main__a5PGa","head":"styles_head__NvLqW","textoCard":"styles_textoCard__t0DNP","sectionConteudo":"styles_sectionConteudo__kQ7l7"};